// extracted by mini-css-extract-plugin
export default {"review":"ReviewProduct_review__I1Kys","card":"ReviewProduct_card__w8MFm"};